export { default as default } from './KitButton';
export type { IProps as KitButtonProps } from './KitButton';
